import React, { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import MobileStickyCTA from "./components/MobileStickyCTA";

// Eager-load only the landing page so it appears fast.
import Homepage from "./pages/Homepage";

// Lazy-load every other page — slashes the initial JS bundle.
const About = lazy(() => import("./pages/About"));
const Products = lazy(() => import("./pages/Products"));
const Delivery = lazy(() => import("./pages/Delivery"));
const ServiceAreas = lazy(() => import("./pages/ServiceAreas"));
const Contact = lazy(() => import("./pages/Contact"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const ServiceDetail = lazy(() => import("./pages/ServiceDetail"));
const Gallery = lazy(() => import("./pages/Gallery"));
const Calculator = lazy(() => import("./pages/Calculator"));

const RouteFallback = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <div className="w-12 h-12 border-4 border-green-800 border-t-transparent rounded-full animate-spin"></div>
  </div>
);

function App() {
  return (
    <div className="App pb-20 lg:pb-0">
      <BrowserRouter>
        <Navbar />
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/delivery" element={<Delivery />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/calculator" element={<Calculator />} />
            <Route path="/service-areas" element={<ServiceAreas />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Suspense>
        <Footer />
        <MobileStickyCTA />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
